import $ from 'jquery'

export default {
  bind(el) {
    $(el).click((event) => {
      event.preventDefault();
      window.open($(el).attr("href"), '_blank');
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/openInNewTabDirectives.js